export default __webpack_public_path__ + "static/media/admin.523b9be0.svg";